import fscreen from 'fscreen';

export const enabledFullscreen = !!(document.fullscreenEnabled
    || (document as any).webkitFullscreenEnabled
    || (document as any).mozFullScreenEnabled
    || (document as any).msFullscreenEnabled);

let isFullscreen = false;
let fullscreenEle = null;

// init
(function () {
    if (!enabledFullscreen) {
        // eslint-disable-next-line @tencent/i18next/no-literal-string
        console.warn('浏览器不支持全屏'); // TODO
        return;
    }

    fscreen.addEventListener('fullscreenchange', () => {
        fullscreenEle = fscreen.fullscreenElement || null;
        isFullscreen = !!(fullscreenEle);
    });
    fscreen.addEventListener('fullscreenerror', () => {
        console.warn('全屏失败'); // TODO
    });
}());

export function requestFullscreen(ele) {
    enabledFullscreen && fscreen.requestFullscreen(ele);
}

export function exitFullscreen() {
    enabledFullscreen && fscreen.exitFullscreen();
}

export const status = {
    get isFullscreen() {
        return isFullscreen;
    },
    get fullscreenEle() {
        return fullscreenEle;
    },
};
